import {get} from 'components/api';
import {profCourse} from 'constants/url';

function getProfCourse(additional: string, token: string) {
  const url = `${profCourse}?additional=${additional}`;
  return get(url, token);
}

export function getProfCourseWithoutAdditional(filters: string, token: string) {
  let options = new URLSearchParams();
  options.append('filter', JSON.stringify(filters));
  const url = `api/ProfSpac/GetProfNoDeletedProfiles?${options && options}`;
  return get(url, token);
}

export default getProfCourse;
